import axios from 'axios'
import apiList from './resource.js'
import newApi from './newApi'

export default {
  // 获取配置
  homeGetConfig: function (successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getConfig'))
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取轮播图
  homeGetBanner: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getBannerNew'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取直播内容
  homeGetLivingData: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getLivingData'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取最新动态
  homeDynamic: function (data, successfn, errorfn) {
    return axios
        .get(newApi.getAjaxUrl('openapi', 'getDynamic'), data)
        .then(res => {
          successfn && successfn(res.data)
        })
        .catch(res => {
          errorfn && errorfn(res.data)
        })
  },
  // 获取首页课程分类
  homeCourseClassify: function (data, successfn, errorfn) {
    return axios
        .post(newApi.getAjaxUrl('openapi', 'getCourseClassify'), data)
        .then(res => {
          successfn && successfn(res.data)
        })
        .catch(res => {
          errorfn && errorfn(res.data)
        })
  },
  // 获取学霸榜信息
  getRankList: function (data, successfn, errorfn) {
    return axios
      .get(apiList.home.getRankList, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取用户自身学霸榜排名信息
  getUserRank: function (data, successfn, errorfn) {
    return axios
      .get(apiList.home.getUserRank, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/home.js